import { Button, Empty, Modal, Radio } from "antd"
import { useState } from "react"
import { Workarea } from "../../../../domain/job"
import { WorkareaGroup } from "../../../../domain/workareas/group"
import VSpace from "../../../common/VSpace"

type Props = {
  visible: boolean
  workarea: Workarea
  workareaGroups: WorkareaGroup[]
  onSubmit: (workareaGroupId: string) => void
  onCancel: () => void
}

const MoveWorkareaModal = ({ visible, workarea, workareaGroups, onCancel, onSubmit }: Props) => {
  const workareaGroupOptions = workareaGroups
    .filter(x => x.id !== workarea.workareaGroupId && !x.isHidden)
    .map(x => ({ value: x.id, label: x.name }))

  const currentGroup = workareaGroups.find(x => x.id === workarea.workareaGroupId)

  const [selectedGroupId, setSelectedGroupId] = useState<string | undefined>()

  const isCurrentGroupHidden = currentGroup?.isHidden ?? true

  return <Modal
    title="Move Work Area"
    open={visible}
    footer={[
      <Button
        key="cancel"
        onClick={onCancel}
      >
        Cancel
      </Button>,
      <Button
        key="ok"
        type="primary"
        onClick={() => onSubmit(selectedGroupId!)}
        disabled={!selectedGroupId}
      >
        OK
      </Button>
    ]}
    onCancel={onCancel}
  >
    <VSpace>
      {(workareaGroupOptions.length > 0 || !isCurrentGroupHidden) && <>
        <span>Where would you like to move <strong>{workarea.name}</strong>?</span>
        <Radio.Group value={selectedGroupId} onChange={e => setSelectedGroupId(e.target.value)}>
          <VSpace>
            {workareaGroupOptions.map(x => {
              return <Radio key={x.value} value={x.value}>
                {x.label}
              </Radio>
            })}
            {currentGroup && !currentGroup.isHidden &&
              <Radio key="move-out" value="move-out">Move out of <strong>{currentGroup.name}</strong></Radio>
            }
          </VSpace>
        </Radio.Group>
      </>}
      {workareaGroupOptions.length === 0 && isCurrentGroupHidden &&
        <Empty description={<>This job has no groups to move this work area into.<br />Create one first before moving the work area.</>} />
      }
    </VSpace>
  </Modal>
}

export default MoveWorkareaModal
